var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { importRemote } from 'module-federation-import-remote';
import { lazy, Suspense, useEffect, useMemo, useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
var Mount = function (_a) {
    var mount = _a.mount, otherProps = _a.otherProps;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            return mount(ref.current, otherProps);
        }
    }, [mount]);
    return _jsx("div", { ref: ref, style: { display: 'contents' } });
};
export var ModuleFederationMount = function (_a) {
    var module = _a.module, subAppModuleFederation = _a.subAppModuleFederation, _b = _a.branchNameSubdomain, branchNameSubdomain = _b === void 0 ? undefined : _b, _c = _a.errorBoundaryFallbackComponent, errorBoundaryFallbackComponent = _c === void 0 ? _jsx(_Fragment, {}) : _c, _d = _a.loadingComponent, loadingComponent = _d === void 0 ? _jsx(_Fragment, {}) : _d, _e = _a.children, children = _e === void 0 ? _jsx(_Fragment, {}) : _e, otherProps = __rest(_a, ["module", "subAppModuleFederation", "branchNameSubdomain", "errorBoundaryFallbackComponent", "loadingComponent", "children"]);
    var Loader = useMemo(function () {
        return lazy(function () {
            return importRemote({
                module: module,
                remoteEntryFileName: subAppModuleFederation.remoteEntryFileName,
                scope: subAppModuleFederation.scope,
                url: subAppModuleFederation.url.replace(/\/$/, ''),
            }).then(function (_a) {
                var mount = _a.mount;
                return ({
                    default: function () { return _jsx(Mount, { mount: mount, otherProps: otherProps }); },
                });
            });
        });
    }, [module, subAppModuleFederation.remoteEntryFileName, subAppModuleFederation.scope, subAppModuleFederation.url, otherProps]);
    return (_jsx(_Fragment, { children: subAppModuleFederation.enabled && (_jsxs(ErrorBoundary, __assign({ onError: function (error) {
                // This error boundary will stop the shell from crashing for sub-applications not deployed in a feature context.
                // Local, dev (outside of a feature context), staging, and production will crash and display an error as expected when a subapp fails to load.
                if (error.message.includes(subAppModuleFederation.remoteEntryFileName) && !!branchNameSubdomain) {
                    console.warn("Ignoring sub-app \"".concat(subAppModuleFederation.appName, "\", error message: ").concat(error.message));
                }
                else {
                    throw error;
                }
            }, fallback: _jsx(_Fragment, { children: errorBoundaryFallbackComponent }) }, { children: [children, _jsx(Suspense, __assign({ fallback: loadingComponent }, { children: _jsx(Loader, {}) }))] }))) }));
};
//# sourceMappingURL=moduleFederationMount.js.map